<template>
    <div class="collapse menu-contents" v-bind:class="{show: isSearchBox,'menu-contents-left':isSearchLeft}" id="MenuSearch">
        <div class="menu-body menu-search">
            <div class="menu-inner">

                <div class="menu-static -search">

                    <!-- form top -->
                    <div class="search-top clearfix">
                        <div class="search-text">
                            <small>検索に必要な条件を入力ください</small>
                        </div>
                        <div class="search-switch">
                            <div class="btn-group" role="group" aria-label="Basic example">
                                <button type="button" class="btn btn-secondary search-switch-left" @click="chgLeftRight">
                                    <span class="icon-left">
                                        <i class="material-icons">arrow_back</i>
                                        左へ移動
                                    </span>
                                    <span class="icon-right">
                                        右へ移動
                                        <i class="material-icons">arrow_forward</i>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div><!-- / search-top -->

                    <!-- form navi -->
                    <nav class="nav-form mb20">
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <a class="nav-item nav-link active" id="form1-tab" data-toggle="tab" href="#form1" role="tab" aria-controls="form1" aria-selected="true">
                                <span class="badge badge-pill badge-custom custom1">和琉</span>
                                日本語からの検索
                            </a>
                            <a class="nav-item nav-link" id="form2-tab" data-toggle="tab" href="#form2" role="tab" aria-controls="form2" aria-selected="false">
                                <span class="badge badge-pill badge-custom custom2">琉和</span>
                                琉球語からの検索
                            </a>
                        </div>
                    </nav><!-- / nav-form -->

                    <!-- form contents -->
                    <div class="tab-content" id="nav-tabContent">

                        <!-- form1 -->
                        <div class="tab-pane fade show active" id="form1" role="tabpanel" aria-labelledby="form1-tab">

                            <form>
                                <!-- form1タブ -->
                                <input id="tab01key" type="radio" name="tabinput" checked>
                                <input id="tab02key" type="radio" name="tabinput">

                                <ul class="tabnav btn-group btn-group-toggle">
                                    <li>
                                        <label class="tabnav01 btn btn-secondary" for="tab01key">
                                            条件検索
                                        </label>
                                    </li>
                                    <li>
                                        <label class="tabnav02 btn btn-secondary" for="tab02key">
                                            50音検索
                                        </label>
                                    </li>
                                </ul>

                                <!-- form1コンテンツ -->
                                <div class="tabcontent">

                                    <!-- form1コンテンツ タブ1 -->
                                    <div id="tabcontent01key">

                                        <div class="form-top-btn">
                                            <div  class="btn btn-red btn-raised" @click="clickSearchJp">検索する</div>
                                        </div>

                                        <div class="tabcontent-in">

                                            <div class="form-keyword">
                                                <div class="form-group mb0" v-bind:class="{errorcolor:jpPanel1IsError}">
                                                    <label for="keyword" class="bmd-label-floating">
                                                        見出し語入力（ひらがな・漢字）
                                                    </label>
                                                     <input type="text" class="form-control" v-model.trim="jpPanel1KeywordBox1">
                                                </div>
                                            </div>

                                            <div class="block border-no">
                                                <div class="block-box -left">
                                                </div>
                                                <div class="block-box -right">
                                                    <label class="radio-inline">
                                                        <input type="radio" name="conditions1" id="conditions1" value="1" v-model="jpPanel1LikeKbn" >
                                                        完全一致
                                                    </label>
                                                    <label class="radio-inline" style="margin-left:10px">
                                                        <input type="radio" name="conditions1" id="conditions2" value="2" v-model="jpPanel1LikeKbn">
                                                       指定の文字で始まる 
                                                    </label>
                                                    <label class="radio-inline" style="margin-left:10px">
                                                        <input type="radio" name="conditions1" id="conditions3" value="3" v-model="jpPanel1LikeKbn">
                                                       指定の文字で終わる
                                                    </label> 
                                                    <label class="radio-inline" style="margin-left:10px">
                                                        <input type="radio" name="conditions1" id="conditions4" value="4" v-model="jpPanel1LikeKbn">
                                                        部分一致
                                                    </label>
                                                </div>
                                            </div><!-- / block -->


                                            <div class="panel pt0">
                                                <div class="block">
                                                    <!-- 辞書選択 -->
                                                   <dic-selector v-on:on-select-update="selectDic1" ref="jpPanel1dic"></dic-selector>
                                                </div><!-- / block -->

                                                    <!--品詞・下位・活用型 -->
                                                    <part-selector v-on:on-select-part="selectPart1" ref="jpPanel1parts"></part-selector>
 

                                                <div class="block">
                                                    <div class="block-box -left">
                                                        音声データ
                                                    </div>
                                                    <div class="block-box -right">
                                                        <label class="checkbox-inline">
                                                            <input type="checkbox" name="voice" id="voice" v-model="jpPanel1IsVoice">
                                                            音声付データのみ
                                                        </label>
                                                    </div>
                                                </div><!-- / block -->

                                                <div class="block border-fotm-top">
                                                    <div class="block-box -left">
                                                        琉球語で更に絞り込む
                                                    </div>
                                                    <div class="block-box -right">
                                                        <div class="form-keyword">
                                                            <div class="form-group mb0">
                                                                <label for="keyword" class="bmd-label-floating">    琉球語入力（カタカナ）
                                                                </label>
                                                                <input type="text" class="form-control" id="keyword" v-model="jpPanel1KeywordBox2">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div><!-- / block -->
                                            </div><!-- / panel -->
                                        </div>
                                        <div class="form-bottom-btn clearfix">
                                            <div class="float-left">
                                                <button type="button" class="btn btn-raised btn-secondary" @click="jpPanel1Clear">クリア</button>
                                                <span class="errormessage">{{jpPanel1ErrorMessage}}</span>
                                            </div>
                                            <div class="float-right">
                                                <div  class="btn btn-red btn-raised" @click="clickSearchJp">検索する</div>
                                            </div>
                                        </div>
                                    </div><!-- / tab1 -->

                                    <!-- form1コンテンツ タブ1 -->
                                    <div id="tabcontent02key">
                                        <div class="tabcontent-in">

                                            <div class="panel pt0">

                                                <div class="block border-none">
                                                    <!-- 辞書選択 -->
                                                   <dic-selector v-on:on-select-update="selectDic2" ref="jpPanel2dic"></dic-selector>
                                                </div><!-- / block -->

                                                <div class="block">
                                                    <!--品詞・下位・活用型 -->
                                                    <part-selector v-on:on-select-part="selectPart2" ref="jpPanel2parts"></part-selector>
         
                                                </div><!-- / block -->

                                                <div class="block border-fotm-bottom">
                                                    <div class="block-box -left">
                                                        音声データ
                                                    </div>
                                                    <div class="block-box -right">
                                                        <label class="checkbox-inline">
                                                            <input type="checkbox" name="voice" id="voice" v-model="jpPanel2IsVoice">
                                                            音声付データのみ
                                                        </label>
                                                    </div>
                                                </div><!-- / block -->

                                            </div><!-- / panel -->


                                            <div class="center">
                                            <table class="table-ja">
                                                <!-- 1行目 -->
                                                <tr>
                                                    <td><a href="#" @click="jpClickWd('ん')">ん</a></td>
                                                    <td><a href="#" @click="jpClickWd('わ')">わ</a></td>
                                                    <td><a href="#" @click="jpClickWd('ら')">ら</a></td>
                                                    <td><a href="#" @click="jpClickWd('や')">や</a></td>
                                                    <td><a href="#" @click="jpClickWd('ま')">ま</a></td>
                                                    <td><a href="#" @click="jpClickWd('は')">は</a></td>
                                                    <td><a href="#" @click="jpClickWd('な')">な</a></td>
                                                    <td><a href="#" @click="jpClickWd('た')">た</a></td>
                                                    <td><a href="#" @click="jpClickWd('さ')">さ</a></td>
                                                    <td><a href="#" @click="jpClickWd('か')">か</a></td>
                                                    <td><a href="#" @click="jpClickWd('あ')">あ</a></td>
                                                </tr>

                                                <!-- 2行目 -->
                                                <tr>
                                                    <td></td>
                                                    <td><!--<a href="#">ゐ</a>--></td>
                                                    <td><a href="#" @click="jpClickWd('り')">り</a></td>
                                                    <td></td>
                                                    <td><a href="#" @click="jpClickWd('み')">み</a></td>
                                                    <td><a href="#" @click="jpClickWd('ひ')">ひ</a></td>
                                                    <td><a href="#" @click="jpClickWd('に')">に</a></td>
                                                    <td><a href="#" @click="jpClickWd('ち')">ち</a></td>
                                                    <td><a href="#" @click="jpClickWd('し')">し</a></td>
                                                    <td><a href="#" @click="jpClickWd('き')">き</a></td>
                                                    <td><a href="#" @click="jpClickWd('い')">い</a></td>
                                                </tr>

                                                <!-- 3行目 -->
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td><a href="#" @click="jpClickWd('る')">る</a></td>
                                                    <td><a href="#" @click="jpClickWd('ゆ')">ゆ</a></td>
                                                    <td><a href="#" @click="jpClickWd('む')">む</a></td>
                                                    <td><a href="#" @click="jpClickWd('ふ')">ふ</a></td>
                                                    <td><a href="#" @click="jpClickWd('ぬ')">ぬ</a></td>
                                                    <td><a href="#" @click="jpClickWd('つ')">つ</a></td>
                                                    <td><a href="#" @click="jpClickWd('す')">す</a></td>
                                                    <td><a href="#" @click="jpClickWd('く')">く</a></td>
                                                    <td><a href="#" @click="jpClickWd('う')">う</a></td>
                                                </tr>

                                                <!-- 4行目 -->
                                                <tr>
                                                    <td></td>
                                                    <td><!--<a href="#" @click="jpClickWd('ん')">ゑ</a>--></td>
                                                    <td><a href="#" @click="jpClickWd('れ')">れ</a></td>
                                                    <td></td>
                                                    <td><a href="#" @click="jpClickWd('め')">め</a></td>
                                                    <td><a href="#" @click="jpClickWd('へ')">へ</a></td>
                                                    <td><a href="#" @click="jpClickWd('ね')">ね</a></td>
                                                    <td><a href="#" @click="jpClickWd('て')">て</a></td>
                                                    <td><a href="#" @click="jpClickWd('せ')">せ</a></td>
                                                    <td><a href="#" @click="jpClickWd('け')">け</a></td>
                                                    <td><a href="#" @click="jpClickWd('え')">え</a></td>
                                                </tr>

                                                <!-- 5行目 -->
                                                <tr>
                                                    <td></td>
                                                    <td><!--<a href="#" @click="jpClickWd('ん')">を</a>--></td>
                                                    <td><a href="#" @click="jpClickWd('ろ')">ろ</a></td>
                                                    <td><a href="#" @click="jpClickWd('よ')">よ</a></td>
                                                    <td><a href="#" @click="jpClickWd('も')">も</a></td>
                                                    <td><a href="#" @click="jpClickWd('ほ')">ほ</a></td>
                                                    <td><a href="#" @click="jpClickWd('の')">の</a></td>
                                                    <td><a href="#" @click="jpClickWd('と')">と</a></td>
                                                    <td><a href="#" @click="jpClickWd('そ')">そ</a></td>
                                                    <td><a href="#" @click="jpClickWd('こ')">こ</a></td>
                                                    <td><a href="#" @click="jpClickWd('お')">お</a></td>
                                                </tr>
                                            </table>
                                            </div>
                                        </div>
                                        <div class="form-bottom-btn clearfix">
                                            <div class="float-left">
                                                <button class="btn btn-raised btn-secondary" type="button" @click="jpPanel2Clear">クリア</button>
                                                <span class="errormessage">{{jpPanel1ErrorMessage}}</span>
                                            </div>
                                        </div>
                                    </div><!-- / tab2 -->
                                </div><!-- / tabcontent -->
                            </form>
                        </div>
                        <!-- form1 END -->

                        <!-- form2 -->
                        <div class="tab-pane fade" id="form2" role="tabpanel" aria-labelledby="form2-tab">

                            <form>
                                <!-- form2タブ -->
                                <input id="tab01" type="radio" name="tabinput" checked>
                                <input id="tab02" type="radio" name="tabinput">

                                <ul class="tabnav btn-group btn-group-toggle">
                                    <li>
                                        <label class="tabnav01 btn btn-secondary" for="tab01">
                                        条件検索
                                        </label>
                                    </li>
                                    <li>
                                        <label class="tabnav02 btn btn-secondary" for="tab02">
                                        50音検索
                                        </label>
                                    </li>
                                </ul>

                                <!-- form2コンテンツ -->
                                <div class="tabcontent">

                                    <!-- form2コンテンツ タブ1 -->
                                    <div id="tabcontent01">

                                        <div class="form-top-btn">
                                                <div  class="btn btn-red btn-raised" @click="clickSearchRy">検索する</div>
                                        </div>

                                        <div class="tabcontent-in">
                                            <div class="form-keyword">
                                                <div class="form-group mb0" v-bind:class="{errorcolor:ryPanel1IsError}">
                                                      <label for="keyword" class="bmd-label-floating">
                                                          琉球語入力（カタカナ）
                                                      </label>
                                                       <input type="text" class="form-control" v-model="ryPanel1KeywordBox1">
                                                </div>
                                            </div>
                                            <div class="block border-no">
                                                <div class="block-box -left">
                                                </div>
                                                <div class="block-box -right">
                                                    <label class="radio-inline">
                                                        <input type="radio" name="conditions1" id="conditions1" value="1" v-model="ryPanel1LikeKbn" >
                                                        完全一致
                                                    </label>
                                                    <label class="radio-inline" style="margin-left:10px">
                                                        <input type="radio" name="conditions1" id="conditions2" value="2" v-model="ryPanel1LikeKbn">
                                                        指定の文字で始まる
                                                    </label>
                                                    <label class="radio-inline" style="margin-left:10px">
                                                        <input type="radio" name="conditions1" id="conditions3" value="3" v-model="ryPanel1LikeKbn">
                                                        指定の文字で終わる
                                                    </label> 
                                                    <label class="radio-inline">
                                                        <input type="radio" name="conditions1" id="conditions4" value="4" v-model="ryPanel1LikeKbn">
                                                        部分一致
                                                    </label>

                                                </div>
                                            </div><!-- / block -->

                                            <div class="panel pt0">

                                                <div class="block">
                                                     <!-- 辞書選択 -->
                                                   <dic-selector v-on:on-select-update="selectDic3" ref="ryPanel1dic"></dic-selector>
                                                </div><!-- / block -->


                                                <div class="block">
                                                     <!--品詞・下位・活用型 -->
                                                    <part-selector v-on:on-select-part="selectPart3" ref="ryPanel1parts"></part-selector>
                                                </div><!-- / block -->

                                                <div class="block">
                                                    <div class="block-box -left">
                                                        意味分野
                                                    </div>
                                                    <div class="block-box -right">
                                                         <v-select v-model="ryPanel1Category" label="categoryname"  multiple :options="categoryData"></v-select> 
                                                    </div>
                                                </div><!-- / block -->

                                                <div class="block">
                                                    <div class="block-box -left">
                                                        音声データ
                                                    </div>
                                                    <div class="block-box -right">
                                                        <label class="checkbox-inline">
                                                            <input type="checkbox" name="voice" id="voice" v-model="ryPanel1IsVoice">
                                                            音声付データのみ
                                                        </label>
                                                    </div>
                                                </div><!-- / block -->

                                                <div class="block">
                                                    <div class="block-box -left">
                                                        標準語で更に絞り込む
                                                    </div>
                                                    <div class="block-box -right">
                                                        <div class="form-keyword">
                                                            <div class="form-group mb0">
                                                              <label for="keyword" class="bmd-label-floating">標準語入力（ひらがな・漢字）</label>
                                                              <input type="text" class="form-control" id="keyword" v-model="ryPanel1KeywordBox2">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div><!-- / block -->
                                            </div><!-- / panel -->
                                        </div>

                                        <div class="form-bottom-btn clearfix">
                                            <div class="float-left">
                                                <button class="btn btn-raised btn-secondary" type="button" @click="ryPanel1Clear">クリア</button>
                                                <span class="errormessage">{{ryPanel1ErrorMessage}}</span>
                                            </div>
                                            <div class="float-right">
                                                <div  class="btn btn-red btn-raised" @click="clickSearchRy">検索する</div>
                                            </div>
                                        </div>
                                    </div><!-- tab1 -->


                                    <!-- form2コンテンツ タブ2 -->
                                    <div id="tabcontent02">
                                        <div class="tabcontent-in">

                                            <div class="panel pt0">

                                                <div class="block border-none">
                                                    <!-- 辞書選択 -->
                                                   <dic-selector v-on:on-select-update="selectDic4" ref="ryPanel2dic"></dic-selector>
                                                </div><!-- / block -->


                                                <div class="block">
                                                    <!--品詞・下位・活用型 -->
                                                    <part-selector v-on:on-select-part="selectPart4" ref="ryPanel2parts"></part-selector>
                                                </div><!-- / block -->



                                                <div class="block">
                                                    <div class="block-box -left">
                                                        意味分野
                                                    </div>
                                                    <div class="block-box -right">
                                                       <v-select v-model="ryPanel2Category" label="categoryname"  multiple :options="categoryData"></v-select> 
                                                    </div>
                                                </div><!-- / block -->

                                                <div class="block border-fotm-bottom">
                                                    <div class="block-box -left">
                                                        音声データ
                                                    </div>
                                                    <div class="block-box -right">
                                                        <label class="checkbox-inline">
                                                            <input type="checkbox" name="voice" id="voice" v-model="ryPanel2IsVoice">
                                                            音声付データのみ
                                                        </label>
                                                    </div>
                                                </div><!-- / block -->

                                            </div><!-- / panel -->

                                            <div class="center">
                                                <table class="table-ry">
                                                    <!-- 1行目 -->
                                                    <tr>
                                                        <td><a href="#" @click="ryClickWd('ン')">ン</a></td>
                                                        <td><a href="#" @click="ryClickWd('ワ')">ワ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ラ')">ラ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ヤ')">ヤ</a></td>
                                                        <td><a href="#" @click="ryClickWd('マ')">マ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ハ')">ハ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ナ')">ナ</a></td>
                                                        <td><a href="#" @click="ryClickWd('タ')">タ</a></td>
                                                        <td><a href="#" @click="ryClickWd('サ')">サ</a></td>
                                                        <td><a href="#" @click="ryClickWd('カ')">カ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ア')">ア</a></td>
                                                    </tr>

                                                    <!-- 2行目 -->
                                                    <tr>
                                                        <td></td>
                                                        <td><!--a href="#" @click="ryClickWd('ヰ')">ヰ</a--></td>
                                                        <td><a href="#" @click="ryClickWd('リ')">リ</a></td>
                                                        <td></td>
                                                        <td><a href="#" @click="ryClickWd('ミ')">ミ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ヒ')">ヒ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ニ')">ニ</a></td>
                                                        <td><a href="#" @click="ryClickWd('チ')">チ</a></td>
                                                        <td><a href="#" @click="ryClickWd('シ')">シ</a></td>
                                                        <td><a href="#" @click="ryClickWd('キ')">キ</a></td>
                                                        <td><a href="#" @click="ryClickWd('イ')">イ</a></td>
                                                    </tr>

                                                    <!-- 3行目 -->
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td><a href="#" @click="ryClickWd('ル')">ル</a></td>
                                                        <td><a href="#" @click="ryClickWd('ユ')">ユ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ム')">ム</a></td>
                                                        <td><a href="#" @click="ryClickWd('フ')">フ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ヌ')">ヌ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ツ')">ツ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ス')">ス</a></td>
                                                        <td><a href="#" @click="ryClickWd('ク')">ク</a></td>
                                                        <td><a href="#" @click="ryClickWd('ウ')">ウ</a></td>
                                                    </tr>

                                                    <!-- 4行目 -->
                                                    <tr>
                                                        <td></td>
                                                        <td><!--a href="#" @click="ryClickWd('ヱ')">ヱ</a--></td>
                                                        <td><a href="#" @click="ryClickWd('レ')">レ</a></td>
                                                        <td></td>
                                                        <td><a href="#" @click="ryClickWd('メ')">メ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ヘ')">ヘ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ネ')">ネ</a></td>
                                                        <td><a href="#" @click="ryClickWd('テ')">テ</a></td>
                                                        <td><a href="#" @click="ryClickWd('セ')">セ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ケ')">ケ</a></td>
                                                        <td><a href="#" @click="ryClickWd('エ')">エ</a></td>
                                                    </tr>

                                                    <!-- 5行目 -->
                                                    <tr>
                                                        <td></td>
                                                        <td><a href="#" @click="ryClickWd('ヲ')">ヲ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ロ')">ロ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ヨ')">ヨ</a></td>
                                                        <td><a href="#" @click="ryClickWd('モ')">モ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ホ')">ホ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ノ')">ノ</a></td>
                                                        <td><a href="#" @click="ryClickWd('ト')">ト</a></td>
                                                        <td><a href="#" @click="ryClickWd('ソ')">ソ</a></td>
                                                        <td><a href="#" @click="ryClickWd('コ')">コ</a></td>
                                                        <td><a href="#" @click="ryClickWd('オ')">オ</a></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="form-bottom-btn clearfix">
                                            <div class="float-left">
                                                <button class="btn btn-raised btn-secondary" type="button" @click="ryPanel2Clear">クリア</button>
                                                              <span class="errormessage">{{ryPanel1ErrorMessage}}</span>
                                            </div>
                                        </div>
                                    </div><!-- tab2 -->
                                </div><!-- / tabcontent -->
                            </form>
                        </div>
                        <!-- form2 END -->

                    </div><!-- tab-content -->
                </div><!-- / menu-static -->
            </div><!-- / menu-inner -->
        </div>
    </div><!-- / menu-contents -->






</template>
<style>
.errorcolor {
    background-color: pink;
}
.errormessage {
    padding-left: 30px;
    color: red;
    font-weight: bold;
}
.checkbox label,
label.checkbox-inline {
    padding-right: 5px !important;
}
</style>
<script>

import dicSelector from './DicSelector.vue'
import partSelector from './PartSelector.vue'
import {API_URL} from '@/services/config'
import vSelect from 'vue-select'

export default {
  name: 'SearchPage',
  props: {
    msg: String
  },
  components:{
        dicSelector,
        partSelector,
        vSelect
  },
  computed:{
      isSearchBox(){
          return this.$store.getters.isSearchBox;
      },
      isSearchLeft(){
          return this.$store.getters.isSearchLeft;
      },
      pageNo(){ /* 選択したページ */
          return this.$store.getters.pageNo;
      },
      pageCurrentNo(){ /* 現在表示中のページ */
          return this.$store.getters.pageCurrentNo;
      }

  },
  watch:{
      /** ページの変更があった場合、該当データを取得 */
      'pageNo':function(){
          var self = this;
          if(this.pageNo !== this.pageCurrentNo){
            //抽出実行
            if(self.searchType=='1' || self.searchType=='2' )
                self.getListJp(); 
            else if(self.searchType=='3' || self.searchType=='4' )
                self.getListRy(); 
          }
      }
  },
  data(){
      return {

            selected: null,


          DicItems:[
            {id:'NKJ',name:'今帰仁'},
            {id:'SNH',name:'首里那覇'},
            {id:'AYM',name:'奄美分類'},
            {id:'SBT',name:'宮古下里'},
            {id:'SDM',name:'龍郷町瀬留'},
            {id:'YRN',name:'与論'},
            {id:'IZN',name:'伊是名'},
            {id:'IEJ',name:'伊江島'},
            {id:'IRB',name:'伊良部'},
            {id:'ISG',name:'石垣'},
            {id:'TKT',name:'竹富'},
            {id:'YNG',name:'与那国'},
            {id:'TNG',name:'種子島'},
            {id:'KGS',name:'鹿児島'}
          ],

          searchType:'',             
          searchJyoken:[],           //検索条件
          categoryData:[],      //カテゴリ
          
          /* 日本語からの検索 */
          /* 条件検索 */
          jpPanel1DicSelect:[],     //辞書選択
          jpPanel1Part:'',          //品詞
          jpPanel1SubPart:'',       //下位品詞
          jpPanel1Inflection:'',    //活用型
          jpPanel1KeywordBox1:'',   //見出し語
          jpPanel1KeywordBox2:'',   //琉球語
          jpPanel1LikeKbn:'1',         //1:完全一致 2:前方一致 3:後方一致 4:部分一致
          jpPanel1ErrorMessage:'',  //エラーメッセージ 
          jpPanel1IsError:false,    //エラー有無   
          jpPanel1IsVoice:false, 

          /* ５０音検索 */
          jpPanel2DicSelect:[],     //辞書選択
          jpPanel2Part:'',          //品詞
          jpPanel2SubPart:'',       //下位品詞
          jpPanel2Inflection:'',    //活用型
          jpPanel2IsVoice:false, 
 
          /* 琉球語からの検索 */
         /* 条件検索 */
          ryPanel1DicSelect:[],     //辞書選択
          ryPanel1Part:'',          //品詞
          ryPanel1SubPart:'',       //下位品詞
          ryPanel1Inflection:'',    //活用型
          ryPanel1Category:'',
          ryPanel1KeywordBox1:'',   //見出し語
          ryPanel1KeywordBox2:'',   //日本語
          ryPanel1LikeKbn:'1',         //1:完全一致 2:前方一致 3:後方一致 4:部分一致
          ryPanel1ErrorMessage:'',  //エラーメッセージ 
          ryPanel1IsError:false,    //エラー有無    
          ryPanel1IsVoice:false, 

          /* ５０音検索 */
          ryPanel2DicSelect:[],     //辞書選択
          ryPanel2Part:'',          //品詞
          ryPanel2SubPart:'',       //下位品詞
          ryPanel2Inflection:'',    //活用型
          ryPanel2Category:'',
          ryPanel2IsVoice:false, 
 
          test1:"data1",
          test2:"data2",

          page:1
      }
  },
  mounted(){
      var self = this;

      self.$axios.get(`${API_URL}/search/getdic`)
      .then((res) => {
          self.DicItems = [];
          self.DicItems = res.data.dicmst;
      });

      self.$axios.get(`${API_URL}/search/getcategory`)
      .then((res) => {
          self.categoryData = res.data;
      });
/*
      self.DicItems.map(function(value){
          self.checkDicJpWord.push(value.id);
      });
      */
      self.isCheckAllDicJpWord = true;
  //    self.checkAllDicJpWord();
  },
  methods:{

      chgLeftRight(){
        var self = this;
        self.$store.dispatch("upIsSearchLeft", !self.isSearchLeft);
      },
      changeSelect ({data, text}) {
      console.log(data)
      this.defaultSelectText = text
    },
      /**
       * 日本語からの検索の実行()
       */



    /************************************** 
     * 日本語からの検索（見出し語)
     **************************************/
      ryPanel1Clear(){

          this.$refs.ryPanel1parts.clear();
          this.$refs.ryPanel1dic.clear();
          this.ryPanel1KeywordBox1='';   //見出し語
          this.ryPanel1KeywordBox2='';   //日本語
          this.ryPanel1LikeKbn='1';         //1:完全一致 2:部分一致
          this.ryPanel1ErrorMessage='';  //エラーメッセージ 
          this.ryPanel1IsError=false;    //エラー有無    
          this.ryPanel1IsVoice=false; 
          this.ryPanel1Category='';
      },
      ryPanel2Clear(){
          this.ryPanel2IsVoice = false;
          this.$refs.ryPanel2parts.clear();
          this.$refs.ryPanel2dic.clear();
          this.ryPanel2Category='';
      },
      // 日本語５０音パネルクリア
      jpPanel2Clear(){
          this.jpPanel2IsVoice = false;
          this.$refs.jpPanel2parts.clear();
          this.$refs.jpPanel2dic.clear();
      },

      // 日本語検索パネルクリア
      jpPanel1Clear(){
          this.$refs.jpPanel1parts.clear();
          this.$refs.jpPanel1dic.clear();
          this.jpPanel1KeywordBox1='';   //見出し語
          this.jpPanel1KeywordBox2='';   //琉球語
          this.jpPanel1LikeKbn='1';         //1:完全一致 2:部分一致
          this.jpPanel1ErrorMessage='';  //エラーメッセージ 
          this.jpPanel1IsError=false;    //エラー有無   
          this.jpPanel1IsVoice=false; 
      },
      selectDic1(v){
          this.jpPanel1DicSelect = v;
      },
      selectPart1(part,subpart,inflection){
         this.jpPanel1Part = part;
         this.jpPanel1SubPart = subpart; 
         this.jpPanel1Inflection = inflection;
      },
      getListJp(){
          var self = this;

          var params = new URLSearchParams();
          params.append('page', self.pageNo);

          self.searchJyoken.forEach(function(val){
              params.append(val.key,val.value);
          }); 
          self.$axios.post(`${API_URL}/search/getlistjp`, params)
          .then((res)=>{
              if(res.data.totalCnt=='0'){
                self.jpPanel1ErrorMessage = "該当する語句はありません";
                return; 
              }
              //self.$store.dispatch('upErrMessage','表示リストを選択して下さい');
              //**表示中のページと抽出ページをあわせる */
              self.$store.dispatch('upPageCurrentNo',self.$store.getters.pageNo);

              self.$store.dispatch('upPageAllCnt',Number(res.data.pageAllCnt));
              self.$store.dispatch('upAllCnt', Number(res.data.totalCnt));
              self.$store.dispatch('upJpListData',res.data);
              self.$store.dispatch('upListType','1');
              this.$router.push('/search', ()=>{});
              this.$store.dispatch('upIsSearchBox',false);
          }); 
      },
      getListRy(){
          var self = this;

          var params = new URLSearchParams();
          params.append('page', self.pageNo);

          self.searchJyoken.forEach(function(val){
              params.append(val.key,val.value);
          }); 
          self.$axios.post(`${API_URL}/search/getlistry`, params)
          .then((res)=>{
              if(res.data.totalCnt=='0'){
                self.ryPanel1ErrorMessage = "該当する語句はありません";
                return; 
              }
              //self.$store.dispatch('upErrMessage','表示リストを選択して下さい');
              //**表示中のページと抽出ページをあわせる */
              self.$store.dispatch('upPageCurrentNo',self.$store.getters.pageNo);
              self.$store.dispatch('upPageAllCnt',Number(res.data.pageAllCnt));
              self.$store.dispatch('upAllCnt', Number(res.data.totalCnt));
              self.$store.dispatch('upJpListData',res.data);
              self.$store.dispatch('upListType','2');
              this.$router.push('/search');
              this.$store.dispatch('upIsSearchBox',false);
          }); 
      },
      clickSearchJp(){
          
          //検索
        var self=this;
        self.jpPanel1ErrorMessage = '';
        self.jpPanel1IsError = false ;

          //入力チェック
        /*
        if(self.jpPanel1KeywordBox1==''){
            self.jpPanel1ErrorMessage = "検索する「見出し語」が入力されていません";
            self.jpPanel1IsError = true;
            return;
        }
        */

        self.searchType = '1';  //日本語条件検索
        self.searchJyoken = [
                             {'key':'searchType' ,'value':self.searchType}, //50音検索
                             {'key':'keyword'    ,'value':self.jpPanel1KeywordBox1},
                             {'key':'keyword2'   ,'value':self.jpPanel1KeywordBox2},
                             {'key':'part'       ,'value':self.jpPanel1Part},
                             {'key':'subpart'    ,'value':self.jpPanel1SubPart},
                             {'key':'inflection' ,'value':self.jpPanel1Inflection},
                             {'key':'likeKbn'    ,'value':self.jpPanel1LikeKbn},
                             {'key':'dic'        ,'value':self.jpPanel1DicSelect},
                             {'key':'isVoice'    ,'value':self.jpPanel1IsVoice},
        ];

        self.$store.dispatch('upPageNo',1);
        self.$store.dispatch('upPageCurrentNo',1);

        self.$store.dispatch('upErrMessage','表示リストを選択して下さい');
        //抽出実行
        self.getListJp(); 
      },
      /*---------------------------------*/
      /* 日本語５０音 */
      /*---------------------------------*/
      jpClickWd(v){

          var self = this;
          self.$store.dispatch('upJpListData',[]);

        self.searchType = '2';  //日本語50音検索
        self.searchJyoken = [
                             {'key':'searchType' ,'value':self.searchType}, //50音検索
                             {'key':'keyword'    ,'value':v},
                             {'key':'part'       ,'value':self.jpPanel2Part},
                             {'key':'subpart'    ,'value':self.jpPanel2SubPart},
                             {'key':'inflection' ,'value':self.jpPanel2Inflection},
                             {'key':'dic'        ,'value':self.jpPanel2DicSelect},
                             {'key':'isVoice'        ,'value':self.jpPanel2IsVoice},
        ];
        self.$store.dispatch('upPageNo',1);
        self.$store.dispatch('upPageCurrentNo',1);

        self.$store.dispatch('upErrMessage','表示リストを選択して下さい');
        //抽出実行
        self.getListJp(); 

      },
      clickSearchRy(){
          
          //検索
          var self=this;

        self.ryPanel1ErrorMessage = '';
        self.ryPanel1IsError = false ;

        //入力チェック
        // if(self.ryPanel1KeywordBox1==''){
        //     self.ryPanel1ErrorMessage = "検索する「琉球語」が入力されていません";
        //     self.ryPanel1IsError = true;
        //     return;
        // }
        var category=[];
        if(Array.isArray(self.ryPanel1Category)){
            self.ryPanel1Category.forEach(function(val){
                category.push(val.categoryid);
            }); 
        }

       self.searchType = '3';  //方言50音検索
        self.searchJyoken = [
                             {'key':'searchType' ,'value':self.searchType}, //50音検索
                             {'key':'keyword'    ,'value':self.ryPanel1KeywordBox1},
                             {'key':'likeKbn'    ,'value':self.ryPanel1LikeKbn},
                             {'key':'part'       ,'value':self.ryPanel1Part},
                             {'key':'subpart'    ,'value':self.ryPanel1SubPart},
                             {'key':'inflection' ,'value':self.ryPanel1Inflection},
                             {'key':'dic'        ,'value':self.ryPanel1DicSelect},
                             {'key':'isVoice'        ,'value':self.ryPanel1IsVoice},
                             {'key':'keyword2'   ,'value':self.ryPanel1KeywordBox2},
                             {'key':'category'   ,'value':category}
        ];
        self.$store.dispatch('upPageNo',1);
        self.$store.dispatch('upPageCurrentNo',1);

        self.$store.dispatch('upErrMessage','表示リストを選択して下さい');
        //抽出実行
        self.getListRy(); 


      },
      /*---------------------------------*/
      /* 方言５０音 */
      ryClickWd(v){

          var self = this;
          self.$store.dispatch('upJpListData',[]);

       var category=[];
        if(Array.isArray(self.ryPanel2Category)){
            self.ryPanel2Category.forEach(function(val){
                category.push(val.categoryid);
            }); 
        }

        self.searchType = '4';  //方言50音検索
        self.searchJyoken = [
                             {'key':'searchType' ,'value':self.searchType}, //50音検索
                             {'key':'keyword'    ,'value':v},
                             {'key':'SearchType' ,'value':self.searchType},
                             {'key':'part'       ,'value':self.ryPanel2Part},
                             {'key':'subpart'    ,'value':self.ryPanel2SubPart},
                             {'key':'inflection' ,'value':self.ryPanel2Inflection},
                             {'key':'dic'        ,'value':self.ryPanel2DicSelect},
                             {'key':'isVoice'        ,'value':self.ryPanel2IsVoice},
                             {'key':'category'   ,'value':category}
        ];
        self.$store.dispatch('upPageNo',1);
        self.$store.dispatch('upPageCurrentNo',1);

        self.$store.dispatch('upErrMessage','表示リストを選択して下さい');
        //抽出実行
        self.getListRy(); 

      },

    /**
     * 日本語からの検索（50音)
     */
      selectDic2(v){
          this.jpPanel2DicSelect = v;
      },
      selectPart2(part,subpart,inflection){
         this.jpPanel2Part = part;
         this.jpPanel2SubPart = subpart; 
         this.jpPanel2Inflection = inflection;
      },

      /**
       * 方言からの検索（見出し語）
       */
      selectDic3(v){
          this.ryPanel1DicSelect = v;
      },
      selectPart3(part,subpart,inflection){
         this.ryPanel1Part = part;
         this.ryPanel1SubPart = subpart; 
         this.ryPanel1Inflection = inflection;
      },

      /**
       * 方言からの検索（50音）
       */
      selectDic4(v){
          this.ryPanel2DicSelect = v;
      },
      selectPart4(part,subpart,inflection){
         this.ryPanel2Part = part;
         this.ryPanel2SubPart = subpart; 
         this.ryPanel2Inflection = inflection;
      },
/*
      checkAllDic(selectDic, isAllCheck){
          var self = this;
          selectDic = [];
          isAllCheck= !isAllCheck; 
          if(isAllCheck===true){
              for(var item in self.DicItems){
                  selectDic.push(self.DicItems[item].id);
              }
          }
      },
      checkDic(){
          var self = this;
          if(self.DicItems.length !==self.checkDicJpWord.length){
              self.isCheckAllDicJpWord = false;
          }else{
              self.isCheckAllDicJpWord = true;
          }
      },
      */

     /*
      checkAllDicJpWord(){
          var self = this;
          self.checkDicJpWord = [];
          self.isCheckAllDicJpWord = !self.isCheckAllDicJpWord; 
          if(self.isCheckAllDicJpWord===true){
              for(var item in self.DicItems){
                  self.checkDicJpWord.push(self.DicItems[item].id);
              }
          }
      },
      clickDicJpWord(){
          var self = this;
          if(self.DicItems.length !==self.checkDicJpWord.length){
              self.isCheckAllDicJpWord = false;
          }else{
              self.isCheckAllDicJpWord = true;
          }
      }
      */
  } 

}
</script>